<div class="drivers-filter d-flex align-items-center justify-content-end gap-3">
	<div class="input-container d-flex justify-content-center align-items-center">
		<div class="icon bg-transparent" [ngClass]="{'disabled': disabled}">
			<i class="ph ph-magnifying-glass border"></i>
		</div>
		<input
			class="input-field search-input rounded-0 border-1 border-end-1 rounded-end-3 border-start-0 ng-untouched ng-pristine ng-valid"
			type="text" [placeholder]="'driverShared.driverSearch.searchDriversPlaceholder' | transloco" [formControl]="searchControl" [ngClass]="{'disabled': disabled}" >
	</div>

	<app-account-filter [disabled]="disabled" [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)">
	</app-account-filter>
</div>